//region :: Imports ::
import {ReactElement, Fragment} from 'react';
import {getAppInsightsPlugin, initializeAppInsights} from './AppInsights';
import MComponent from '../Component';
import withRouter from '../../WithRouter';
import {withAITracking} from '@microsoft/applicationinsights-react-js';

//endregion

/** */
type Props = {
    connectionString: string;
    children: JSX.Element | JSX.Element[] | string;
};

/** */
type State = {
    initialized: boolean;
}

/** */
class AITelemetryProvider extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);
        this.initializeState();
    }

    /** */
    private initializeState(): void {
        this.state = {initialized: false};
    }

    /** */
    public componentDidMount(): void {

        if(this.state.initialized) {
            return;
        }

        initializeAppInsights(this.props.connectionString);
        this.safeSetState((draft: State) => draft.initialized = true);

    }

    /** */
    public render(): ReactElement {

        return (
            <Fragment>
                {this.props.children}
            </Fragment>
        );

    }

}

export default withRouter(withAITracking(getAppInsightsPlugin()!, AITelemetryProvider));
